var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MasterCardLogo = function () {
    return (_jsxs("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [_jsx("rect", { fill: "#252525", height: "16", rx: "2", width: "24" }), _jsx("circle", { cx: "9", cy: "8", fill: "#eb001b", r: "5" }), _jsx("circle", { cx: "15", cy: "8", fill: "#f79e1b", r: "5" }), _jsx("path", { d: "m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z", fill: "#ff5f00" })] })));
};
